/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import * as React from 'react'
import Pagination from '../../../../components/TablePagination'
import { type SnackbarOrigin } from '@mui/material/Snackbar'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import Paper from '@mui/material/Paper'
import Checkbox from '@mui/material/Checkbox'
import { visuallyHidden } from '@mui/utils'
import LanguageStrings from '../../../../i18n/locales'
import { fetchRegReadTableData } from '../../redux/actionCreator'
import { connect, useSelector } from 'react-redux'
import { CircularProgress } from '@mui/material'
import AuthError from '../../../../components/ErrorComponents/AuthError'
import { useAuth } from 'react-oidc-context'
import { parseDateInAOHstandard } from '../../../../customHooks/parseDate'

import { type RootState } from '../../../../store'
export interface State extends SnackbarOrigin {
  open: boolean
}
interface Data {
  register: string
  measurementPeriod: Date | null
  eventType: string
  collected: string
  calculated: string
  deltaValue: string
  lastUpdated: Date | null
}

const style = {
  width: '99%',
  bgcolor: '#313030',
  border: '1px solid #101010',
  borderRadius: '10px',
  boxShadow: '1px 1px 1px rgba(0, 0, 0, 0.15)',
  marginBottom: '16px',
  padding: 0
}

type Order = 'asc' | 'desc'
interface HeadCell {
  disablePadding: boolean
  id: any
  label: string
  numeric: boolean
}

const TableStrings = LanguageStrings().DatasourceStrings.DeviceTableRegReading

function EnhancedTableHead (props: any): any {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, deviceList, assetType, deviceType } = props
  const isEi6OrEi7 = (deviceType as string).toLowerCase() === 'gas-ei6' || (deviceType as string).toLowerCase() === 'gas-ei7'
  const shouldShowThirdColumn = assetType === 'Gas' ? isEi6OrEi7 : true
  const headCells: readonly HeadCell[] = [
    {
      id: 'REGISTER',
      numeric: false,
      disablePadding: false,
      label: isEi6OrEi7 ? TableStrings.parameter : TableStrings.register
    },
    {
      id: 'MEASUREMENT PERIOD',
      numeric: false,
      disablePadding: false,
      label: TableStrings.measurementPeriod
    },
    ...(shouldShowThirdColumn
      ? [{
          id: 'COLLECTED',
          numeric: false,
          disablePadding: false,
          label: assetType === 'Water' ? TableStrings.consumption : TableStrings.meterIndex
        }]
      : []),
    {
      id: 'indexValue',
      numeric: false,
      disablePadding: false,
      label: isEi6OrEi7 ? TableStrings.consumption : TableStrings.meterIndex
    }
  ]
  const createSortHandler =
        (newOrderBy: keyof Data) => (event: React.MouseEvent<unknown>) => {
          onRequestSort(event, newOrderBy)
        }
        // istanbul ignore next
  if (deviceList !== null && deviceList !== undefined) {
    return (
        <TableHead data-testid="table-header">
            <TableRow>
                <StyledTableCell padding="checkbox" style={{ display: 'none' }} >
                    <Checkbox
                        sx={{ color: '#909090' }}
                        data-testid="device-table-header-checkbox"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                          'aria-label': 'select all devices', id: 'select-all-items'
                        }}
                    />
                </StyledTableCell>
                {headCells.map((headCell: HeadCell, index) => (
                    <StyledTableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                      {index === 0
                        ? (
                            headCell.label
                          )
                        : (
                        <TableSortLabel
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            aria-label={headCell.label}
                            data-testid="test-sort"

                        >
                            {headCell.label}
                            {orderBy === headCell.id
                              ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                                )
                              : null}
                        </TableSortLabel>
                          )}
                    </StyledTableCell>
                ))}
            </TableRow>
        </TableHead>
    )
  }
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: '#F0F0F0',
    fontWeight: '700',
    fontSize: 12,
    border: '2px solid #202020',
    padding: '5px 16px',
    fontFamily: 'Honeywell Sans Web'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: '#d0d0d0',
    paddingLeft: '17px',
    borderBottom: '1px solid #202020',
    borderRight: 0,
    fontFamily: 'Honeywell Sans Web'
  }
}))

interface Sort {
  order: Order
  orderBy: string
}

function DeviceList (props: any): JSX.Element {
  const rowsPerPage = 5
  const auth = useAuth()
  const assetById = useSelector((state: RootState) => state.assetById)
  const [selected, setSelected] = React.useState<readonly string[]>([])
  const [page, setPage] = React.useState(1)
  const [sort, setSort] = React.useState<Sort>({ order: 'desc', orderBy: 'readingTime' })
  const [deviceList, setDeviceList] = React.useState([])
  const [assetType, setAssetType] = React.useState('Water')
  const [deviceType, setDeviceType] = React.useState('water-merlin')
  const isEi6OrEi7 = deviceType?.toLowerCase() === 'gas-ei6' || deviceType?.toLowerCase() === 'gas-ei7'
  let paramAssetId = sessionStorage.getItem('paramAssetId')
  if (paramAssetId === null) {
    paramAssetId = ''
  }

  React.useEffect(() => {
    if (assetById !== undefined && assetById.assetData !== null) {
      setAssetType(assetById.assetData.device_type.toUpperCase().includes('GAS') ? 'Gas' : 'Water')
      setDeviceType(assetById.assetData.device_type.toLowerCase())
    }
  }, [assetById])

  React.useEffect(() => {
    props.fetchRegReadTableData(paramAssetId ?? '', page, rowsPerPage, auth.user?.profile.customer as string, sort.order, sort.orderBy)
  }, [page, sort])

  const handleRetry = (): any => {
    props.fetchRegReadTableData(paramAssetId ?? '', page, rowsPerPage, auth.user?.profile.customer as string, sort.order, sort.orderBy)
  }

  React.useEffect(() => {
    setDeviceList(props.tableData || [])
  }, [props.tableData])

  // istanbul ignore next
  const handleRequestSort =
        (event: React.MouseEvent<unknown>, newOrderBy: keyof Data): any => {
          const isAsc = sort.orderBy === newOrderBy && sort.order === 'asc'
          const toggledOrder = isAsc ? 'desc' : 'asc'
          setSort({ order: toggledOrder, orderBy: newOrderBy })
        }

  // istanbul ignore next
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>): any => {
    if (event.target.checked) {
      const newSelected: any = deviceList.map((n: any) => n.deviceId)
      setSelected(newSelected)
      return
    }
    setSelected([])
  }

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '& th': {
      border: '1px solid #202020'
    }
  }))

  const isSelected = (name: string): any => selected.includes(name)
  const shouldShowThirdColumn = assetType === 'Gas' ? isEi6OrEi7 : true
  if (props.tableData !== undefined && props.tableData.isLoading) {
    return (
      <div className="CircularprogressAmi">
        <CircularProgress />
      </div>
    )
    // istanbul ignore next
  } else if (props.tableData !== undefined && props.tableData.httpStatus === 401) {
    return (
      <div className="authError">
        <AuthError errorMessage="Unauthorized" />
      </div>
    )
    // istanbul ignore next
  } else if (props.tableData !== undefined && props.tableData.httpStatus === 403) {
    return (
      <div className="authError">
        <AuthError errorMessage="accessForbidden" />
      </div>
    )
    // istanbul ignore next
  } else if (props.tableData !== undefined && props.tableData.httpStatus === 200 && props.tableData.errorMessage === true) {
    return (
      <div className="authError">
        <AuthError errorMessage="NoDataPresent" />
      </div>
    )
    // istanbul ignore next
  } else if (props.tableData !== undefined && props.tableData.httpStatus === 404 && props.tableData.errorMessage === 'No data found') {
    return (
      <div className="authError">
        <AuthError errorMessage="NoDataPresent" />
      </div>
    )
    // istanbul ignore next
  } else if (
    props.tableData !== undefined &&
    props.tableData.tableData !== null &&
    props.tableData.tableData !== undefined &&
    props.tableData.httpStatus === 200
  ) {
    return (
      <>
        <Box sx={style} className="devices">
          <Paper
            sx={{
              width: '100%',
              mb: 2,
              backgroundColor: '#272727',
              boxShadow: 'unset',
              color: '#F0F0F0',
              marginBottom: '0'
            }}
          >
            <TableContainer className="device-table">
              <Table
                sx={{ minWidth: 750, color: '#f0f0f0' }}
                aria-labelledby="tableTitle"
                size={'small'}
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={sort.order}
                  orderBy={sort.orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={5}
                  deviceList={props.tableData.tableData}
                  assetType={assetType}
                  deviceType={deviceType}
                />
                <TableBody>
                  {props.tableData.tableData &&
                    props.tableData.tableData.map((row: any, index: any) => {
                      const isItemSelected = isSelected(row.id)
                      const labelId = `enhanced-table-checkbox-${index}`

                      return (
                        <StyledTableRow
                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.deviceId}
                          aria-label="devices-list-row"
                          selected={isItemSelected}
                        >
                          <StyledTableCell
                            padding="checkbox"
                            style={{ display: 'none' }}
                          >
                            <Checkbox
                              sx={{ color: '#909090' }}
                              checked={isItemSelected}
                              inputProps={{
                                'aria-labelledby': labelId,
                                'aria-label': 'test-checkbox',
                                id: `select-item-${index}`
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            id={labelId}
                            scope="row"
                            padding="none"
                            aria-label="device-name"
                            data-testid="device-name"
                          >
                            {row.register}
                          </StyledTableCell>
                          <StyledTableCell>
                            {parseDateInAOHstandard(row.measurementPeriod)}
                          </StyledTableCell>
                          {shouldShowThirdColumn && <StyledTableCell>{row.collected}</StyledTableCell>}
                          <StyledTableCell>{row.calculatedValue}</StyledTableCell>
                        </StyledTableRow>
                      )
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            {props.tableData.deviceCount > rowsPerPage && (<Pagination
              count={props.tableData.deviceCount}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              siblingCount={1}
              boundaryCount={1}
            />)}
          </Paper>
        </Box>
      </>
    )
  } else {
    return (
      <div className="authError">
        <AuthError errorMessage="cannotFetch" retry={handleRetry} />
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch: any): any => ({
  fetchRegReadTableData: (assetId: string, page: string, size: string, tenantId: string, sortdir: string, sortfield: string) => dispatch(fetchRegReadTableData(assetId, page, size, tenantId, sortdir, sortfield))
})

const mapStateToProps = (state: any): any => ({
  tableData: state.registerReadingsData
})

export default connect(mapStateToProps, mapDispatchToProps)(DeviceList)
